const getInputDateString = (date) => {
  const selectDate = new Date(date);
  const month =
    selectDate.getMonth() + 1 < 10
      ? `0${selectDate.getMonth() + 1}`
      : selectDate.getMonth() + 1;
  const day =
    selectDate.getDate() < 10
      ? `0${selectDate.getDate()}`
      : selectDate.getDate();
  return `${selectDate.getFullYear()}-${month}-${day}`;
};
export default getInputDateString;
